module.exports = __webpack_public_path__ + "img/b845e1a.svg";